export function isTextElement(node) {
    return (node instanceof HTMLInputElement || node instanceof HTMLTextAreaElement);
}
export function isFormMember(node) {
    return (node instanceof HTMLInputElement ||
        node instanceof HTMLTextAreaElement ||
        node instanceof HTMLSelectElement);
}
